import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Router from 'vue-router'
import Calls from '@/components/calls'
import Callslist from '@/components/callslist'
import Baselist from '@/components/baseList'
import Clients from '@/components/clients'
import MainPage from '@/components/mainPage'
import Monitoring from '@/components/monitoring'
import Stat from '@/components/stat'
import Settings from '@/components/settings'
import Users from '@/components/users'
import Projects from '@/components/projects'
import Chart from '@/components/chart'
import Help from '@/components/help'
import DiagramEditor from '@/components/diagramEditor'
import SimCallsProjects from '@/components/simCalls/projects'
import SimCallsBases from '@/components/simCalls/bases'
import SimCallsGateways from '@/components/simCalls/gateways'
import SimCallsProviders from '@/components/simCalls/providers'

Vue.use(Router)
Vue.use(VueAxios, axios)

export default new Router({
  mode: 'history',
  routes: [
    {path: '/', name: 'main page', component: MainPage},
    {path: '/monitoring', name: 'monitoring', component: Monitoring},
    {path: '/calls', name: 'calls', component: Calls},
    {path: '/callslist', name: 'callslist', component: Callslist},
    {path: '/baselist', name: 'baselist', component: Baselist},
    {path: '/projects', name: 'projects', component: Projects},
    {path: '/clients', name: 'clients', component: Clients},
    {path: '/stat', name: 'statistic', component: Stat},
    {path: '/settings', name: 'settings', component: Settings},
    {path: '/users', name: 'users', component: Users},
    {path: '/chart', name: 'chart', component: Chart},
    {path: '/help', name: 'help', component: Help},
    {path: '/diagramEditor', name: 'diagramEditor', component: DiagramEditor},
    {path: '/simCallsProjects', name: 'SimCallsProjects', component: SimCallsProjects},
    {path: '/simCallsBases', name: 'SimCallsBases', component: SimCallsBases},
    {path: '/simCallsGateways', name: 'SimCallsGateways', component: SimCallsGateways},
    {path: '/simCallsProviders', name: 'SimCallsProviders', component: SimCallsProviders}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js